import range from './rangeOperations';

export default {
  getWeekends(fromDate, toDate, gmt = 3) {
    const saturdays = [];
    const date = new Date(fromDate);

    date.setUTCHours(0, 0, 0, 0);

    while (date.getUTCDay() !== 6) {
      date.setUTCDate(date.getUTCDate() - 1);
    }

    do {
      saturdays.push(new Date(date));
      date.setUTCDate(date.getUTCDate() + 7);
    } while (date <= toDate);

    saturdays.forEach(d => d.setUTCHours(d.getUTCHours() - gmt));

    return saturdays;
  },

  getWeekendPeriods(fromDate, toDate, gmt = 3) {
    const src = this.getWeekends(fromDate, toDate, gmt);

    return src.map(w => [
      w.getTime(),
      w.getTime() + 2 * 24 * 3600 * 1000 - 1,
    ]);
  },

  sumPeriodsInMinutes(periods, toDate, gmt = 3) {
    const minDate = Math.min(new Date, ...periods.reduce((acc, val) => [...acc, ...val], []));
    const weekends = this.getWeekendPeriods(new Date(minDate), toDate, gmt);

    const toMinutes = d => Math.ceil(d / (1000 * 60));

    const toCombine = periods.map(([a, b]) => [toMinutes(a), toMinutes(b)]);
    const toSubtract = weekends.map(([a, b]) => [toMinutes(a), toMinutes(b)]);


    // const toCombineFlat = toCombineInMinutes.reduce((acc, val) => ({ ...acc, ...val }), {});
    // const toSubtractFlat = toSubtractInMinutes.reduce((acc, val) => ({ ...acc, ...val }), {});
    // const minTimeMins = Math.min(...toCombineFlat, ...toSubtractFlat);

    let combined = range.sum(toCombine);

    for (let i = 0; i < toSubtract.length; i++) {
      combined = range.diff(combined, toSubtract[i]);
    }

    return combined.reduce((acc, val) => acc + Math.max(...val) - Math.min(...val), 0);
  }
}



